module.exports = __webpack_public_path__ + "static/media/Quam-Icon-RightArrow.129ca0ab.svg";